import React, { useEffect, useState, useMemo } from "react";
import DetailEvent from "../../components/DetailEvent";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { GeneralStyle } from "./DetailEventsContainer.styled";
import imgBackgroundSpeaker from "../../assets/speakers-background.png";
import { useLazyQuery, useMutation } from "@apollo/client";
import { EVENT_BY_ID } from "../../GraphQL/Queries";
import { NotificationManager } from "react-notifications";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { theme as themeConfig } from "../../themes/themes";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import {
  PARTICIPANT_ATTEND_CHANGE,
  REGISTER_TO_PUBLIC_EVENT,
  CREATE_EVENT_FEEDBACK,
} from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import imgOneOrOneRequest from "../../assets/img-oneorone-request.jpeg";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import moment from "moment";

const DetailEventsContainer = () => {
  const options = { weekday: "short", month: "short", day: "numeric" };
  const location = useLocation();
  const history = useHistory();
  const user = useMemo(() => getStateLoginComplete(), []);
  const event = useMemo(() => location.state.event, []);
  const eventId = useMemo(() => location.state.idEvent, []);
  const [data, setData] = useState({});
  const [detailEvent, setDetailEvent] = useState({});
  const [duration, setDuration] = useState();
  const [activeCancel, setActiveCancel] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [activeSave, setActiveSave] = useState(true);

  const [registerToPublicEvent] = useMutation(REGISTER_TO_PUBLIC_EVENT, {
    client: clientWellness,
  });
  const [participantAttendChange] = useMutation(PARTICIPANT_ATTEND_CHANGE, {
    client: clientWellness,
  });
  const [createEventFeedback] = useMutation(CREATE_EVENT_FEEDBACK, {
    client: clientWellness,
  });

  const [
    runQueryEventById,
    { loading: loadingEventById, error: errorEventById },
  ] = useLazyQuery(EVENT_BY_ID, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.eventById !== null && data.eventById) {
        setData(data.eventById);
      } else {
        NotificationManager.error(
          "Something is wrong with the detail of the event",
          "",
          5000
        );
      }
    },
  });

  useEffect(() => {
    if (data !== null) {
      if (data.startDate && data.finishDate) {
        diff_hours(data.startDate, data.finishDate);
      }
    } else {
      history.push({
        pathname: `/Gamification`,
      });
      setTimeout(() => {
        history.push({
          pathname: `/EventManager`,
        });
      }, 0);
    }
  }, [data.startDate, data.finishDate, data]);

  useEffect(() => {
    if (eventId) {
      runQueryEventById({
        variables: {
          eventId: eventId,
        },
      });
    } else {
      history.push({
        pathname: `/Gamification`,
      });
      setTimeout(() => {
        history.push({
          pathname: `/EventManager`,
        });
      }, 0);
    }
  }, [eventId]);

  const goToBackPage = () => {
    history.push({ pathname: location.state.path });
  };

  const diff_hours = (date1, date2) => {
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
    diff /= 60 * 60;
    let duration = Math.abs(diff);
    setDuration(duration);
  };

  const saveFeedback = (id, comments, rating) => {
    if (id) {
      createEventFeedback({
        variables: {
          rating,
          observations: comments,
          idEvent: id,
        },
      })
        .then((res) => {
          if (res?.data?.createEventFeedBack) {
            NotificationManager.success(
              "Thank you for your feedback",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  const saveRegister = () => {
    setShowLoader(true);
    registerToPublicEvent({
      variables: {
        eventId: detailEvent?.idEvent,
      },
    })
      .then((response) => {
        setActiveSave(!activeSave);
        setActiveCancel(!activeCancel);
        if (detailEvent?.recurrenceEndDate || detailEvent?.recurrencePattern) {
          NotificationManager.success(
            "Your were register in all the serie",
            "",
            5000
          );
        } else {
          NotificationManager.success("save register successfully", "", 5000);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setShowLoader(false);
      });
  };

  const saveAccept = () => {
    setShowLoader(true);
    participantAttendChange({
      variables: {
        eventId: detailEvent?.idEvent,
        userId: user.userId,
        participantAttend: "Accept",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    })
      .then((response) => {
        setActiveSave(!activeSave);
        setActiveCancel(!activeCancel);
        NotificationManager.success(
          "save participant attend successfully",
          "",
          5000
        );
        setShowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setShowLoader(false);
      });
  };

  const saveCancel = () => {
    setShowLoader(true);
    participantAttendChange({
      variables: {
        eventId: detailEvent?.idEvent,
        userId: user.userId,
        participantAttend: "Decline",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    })
      .then((response) => {
        setActiveSave(!activeSave);
        setActiveCancel(!activeCancel);
        history.push({
          pathname: `/MyCalendar`,
        });
        NotificationManager.success("cancel register successfully", "", 5000);
        setShowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setShowLoader(false);
      });
  };

  const saveDecline = () => {
    setShowLoader(true);
    participantAttendChange({
      variables: {
        eventId: detailEvent?.idEvent,
        userId: user.userId,
        participantAttend: "Decline",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    })
      .then((response) => {
        setActiveSave(!activeSave);
        setActiveCancel(!activeCancel);
        NotificationManager.success("declined successfully", "", 5000);
        setShowLoader(false);
        goToBackPage();
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setShowLoader(false);
      });
  };
  useEffect(() => {
    if (data && duration && event) {
      let showAccept = [];
      showAccept = data?.wellnessParticipants?.filter((e) => {
        return e?.userId === user?.userId && e?.attendStatus === "Accept";
      });
      let startDate = event && event.start ? event.start : data.startDate;
      setDetailEvent({
        idEvent: data.idEvent,
        startDate: new Date(startDate)
          .toLocaleDateString("en-US", options)
          .toUpperCase(),
        startTime: moment(startDate).format("hh:mm a"),
        endDate: data.finishDate,
        endTime: moment(data.finishDate).format("hh:mm a"),
        duration: duration,
        status: showAccept[0]?.attendStatus,
        attendees:
          data.wellnessParticipants && data.wellnessParticipants.length,
        idCategoryNavigation: data.idCategoryNavigation,
        wellnessParticipants: data.wellnessParticipants,
        wellnessSearchGroupUsers: data.wellnessSearchGroupUsers,
        speakers: data?.wellnessSpeakerEvents,
        meetingUrl: data.urlEvent,
        meetingDescription: "Join on:",
        meetingLanguage:
          data.idLanguageNavigation && data.idLanguageNavigation.label,
        aboutTitleEvent: data.eventName,
        aboutTitle: "About the Event",
        aboutDescription: data.description,
        idCategory: data.idCategory,
        eventType: data.eventType,
        photoRegister:
          data.idCategory === 1 ? imgOneOrOneRequest : data.urlPhoto,
        attendeesList: data.wellnessParticipants,
        recurrenceEndDate: data.recurrenceEndDate,
        recurrencePattern: data.recurrencePattern,
      });
    }
  }, [data, duration, event]);

  return (
    <>
      <GeneralStyle>
        {loadingEventById && !errorEventById && (
          <Row>
            <Col
              md="12"
              className="d-flex justify-content-center align-content-center my-5"
            >
              <PointersLine color={themeConfig.text.primary} />
            </Col>
          </Row>
        )}
        {!loadingEventById && errorEventById && (
          <Row>
            <Col
              md="12"
              className="d-flex justify-content-center align-content-center my-5"
            >
              <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
            </Col>
          </Row>
        )}
        {!loadingEventById && !errorEventById && (
          <DetailEvent
            detailEvent={detailEvent}
            buttonRegister={"Register"}
            buttonAccept={"Accept"}
            buttonCancel={"Cancel"}
            buttonDecline={"Decline"}
            buttonSpeaker={"Read More"}
            goToBackPage={goToBackPage}
            saveRegister={saveRegister}
            saveAccept={saveAccept}
            saveCancel={saveCancel}
            saveDecline={saveDecline}
            backgroundSpeaker={imgBackgroundSpeaker}
            activeSave={activeSave}
            setActiveSave={setActiveSave}
            activeCancel={activeCancel}
            setActiveCancel={setActiveCancel}
            saveFeedback={saveFeedback}
            user={user}
          />
        )}
        {showLoader && <ModalLoader />}
      </GeneralStyle>
    </>
  );
};

export default DetailEventsContainer;
